import { ITheme } from '@fluentui/react';
import React from 'react';
import { ContentType } from '../../../web-legacy/models/apiModels';
import { StyledText } from '../../common/components/StyledText';
import { getString } from '../../utils/stringLoader';
import { TagStackStyle } from '../styles/selfHelpStyles';
import { isCommunityContent } from '../../utils/contentTypeUtils';

export const Tag = (props: { useTag: boolean; contentType: ContentType; theme: ITheme }): JSX.Element => {
  return (
    <StyledText styles={TagStackStyle(props.theme.palette.neutralLight)}>
      {!!props.useTag
        ? isCommunityContent(props.contentType)
          ? getString('GetHelp_AMC')
          : getString('GetHelp_SMC')
        : null}
    </StyledText>
  );
};
